module.exports = __webpack_public_path__ + "static/media/exukonline-bitcoin.b581a44a.png";